export default "__VITE_ASSET__BZTXSHFm__"